import {useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";

import {saveTokens} from "@/lib/services/tokenService";
import {Button, Card, Divider, Input, Spin} from 'antd';

import RenderIf from "@/components/render-if";
import {URLS} from "@/lib/urls";
import Timer from "@/components/timer";
import {useApiAuthRegister, useApiGetOtp, useApiLoginByOtp, useApiRecoveryPassword, useApiSendOtp} from "@/api/auth";


import {formatMobileNumber, toEnglishDigits} from "@/lib/utils/number";
import AuthCardHeaderSection from "@/pages/auth/_section/AuthCardHeaderSection";
import {AuthFooterLinkNewMobileSection} from "@/pages/auth/_section/AuthFooterLinkNewMobileSection";
import {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";

export default function StateOtpSection({myData, setMyData, setMyMobile, myMobile, changeMyState}) {

    const navigate = useNavigate();
    const [otpValue, setOtpValue] = useState('')
    const [xData, setXData] = useState({})
    const [inAppData, setInAppData] = useState()
    const [myOtpDetail, setMyOtpDetail] = useState({})
    const [myOtpToken, setMyOtpToken] = useState()
    const {mutate: loginByOtp, isPending: isPendingLBO} = useApiLoginByOtp()
    const {mutate: recoveryPassword, isPending: isPendingRP} = useApiRecoveryPassword()
    const {mutate: registerUser, isPending: isPendingRG} = useApiAuthRegister()

    useEffect(() => {
        setXData(myData)
    }, [myData])

    // useEffect(() => {
    //     if ('OTPCredential' in window) {
    //         const ac = new AbortController();
    //
    //         navigator.credentials.get({
    //             otp: { transport: ['sms'] },
    //             signal: ac.signal
    //         }).then(otp => {
    //             if (otp && otp.code) {
    //                 setOtpValue(otp.code);
    //                 handleAuth(otp.code);
    //             }
    //         }).catch(err => {
    //
    //         });
    //
    //         return () => ac.abort();
    //     }
    // }, []);


    useEffect(() => {
        setInAppData(myData)
    }, [myData])


    useEffect(() => {
        if (otpValue.length === 5) {
            handleAuth()
        }
    }, [otpValue]);


    useEffect(() => {
        if (inAppData?.otpToken) {
            setMyOtpToken(inAppData.otpToken)
        }
    }, [inAppData])

    let isPending = isPendingLBO || isPendingRP || isPendingRG


    const handleAuth = (signalOtp = null) => {

        let myOtpValue = otpValue ?? signalOtp

        if (!myOtpValue) {
            return;
        }

        myOtpValue = toEnglishDigits(myOtpValue)

        if (xData?.callFrom === 'register') {
            // update user
            // refetch login data
            registerUser({
                displayname: inAppData?.displayname,
                password: inAppData?.password,
                password_confirmation: inAppData?.password,
                mobile: formatMobileNumber(myMobile),
                otp: myOtpValue,
                otp_token: myOtpToken,
            }, {
                onSuccess: (r) => {
                    saveTokens({
                        accessToken: r.data?.data?.access_token,
                        refreshToken: r.data?.data?.refresh_token,
                        rememberMe: true
                    });
                    navigate(URLS.gateway.selector, {replace: true})

                },
                onError: (error) => {
                    ApiHandleErrorMessage(error);
                }
            })
        } else {
            if (xData?.callFrom === 'recovery') {
                // update user
                // refetch login data
                recoveryPassword({

                    password: inAppData?.password,
                    password_confirmation: inAppData?.password,
                    mobile: formatMobileNumber(myMobile),
                    otp: myOtpValue,
                    otp_token: myOtpToken,
                }, {
                    onSuccess: (r) => {
                        saveTokens({
                            accessToken: r.data?.data?.access_token,
                            refreshToken: r.data?.data?.refresh_token,
                            rememberMe: true
                        });
                        navigate(URLS.gateway.selector, {replace: true})

                    },
                    onError: (error) => {
                        ApiHandleErrorMessage(error);
                    }
                })
            } else {
                loginByOtp({mobile: formatMobileNumber(myMobile), otp: myOtpValue, otp_token: myOtpToken}, {
                    onSuccess: (r) => {

                        saveTokens({
                            accessToken: r.data?.data?.access_token,
                            refreshToken: r.data?.data?.refresh_token,
                            rememberMe: true
                        });


                        navigate(URLS.gateway.selector, {replace: true})
                    }, onError: (error) => {
                        ApiHandleErrorMessage(error);
                    }
                })
            }

        }

    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleAuth
            ()
        }
    };


    return (
        <>
            <Card>
                <AuthCardHeaderSection title={'تایید موبایل'}
                                       description={<>
                                           <div>
                                               لطفا جهت احراز هویت خود کد پیامک شده به موبایل خود را وارد کنید
                                           </div>
                                           <div>
                                               <RenderIf condition={myOtpDetail?.login_by_national_code}>


                                                   <br/>
                                                   شماره موبایل ثبت شده شما در سیستم
                                                   <span className={'font-bold mx-1 ltr inline-block'}
                                                         style={{direction: "ltr", display: "inline-block"}}>
                                                   {myOtpDetail?.mobile}</span>
                                                   می‌باشد
                                               </RenderIf>
                                           </div>


                                       </>}/>
                <div className={'mt-4'}>
                    <div className={`flex flex-col w-full justify-center`}>
                                    <span
                                        className={`text-md font-medium pt-2 pb-1`}>کد تایید</span>
                        <div className={'flex w-full justify-center'}>

                            <Input.OTP

                                onKeyDown={handleKeyDown}
                                placeholder="کد تایید"
                                size="large"
                                disabled={isPending}
                                autoComplete="off"
                                type={'tel'}
                                style={{direction: "ltr"}}
                                dir={'ltr'}
                                required
                                autoFocus
                                length={5}
                                value={otpValue}
                                onChange={(str) => setOtpValue(str)}
                            />
                        </div>
                    </div>


                    <div className="flex-1"/>

                    <div className="flex flex-col items-center gap-2">

                        <Button type={'primary'} className={'w-full mt-8'} onClick={handleAuth} loading={isPending}>
                            بررسی کد
                        </Button>

                        <Divider type={'horizontal'}/>
                        <AuthOTPTimer mobile={myMobile} otpToken={myOtpToken} setOtpToken={setMyOtpToken}
                                      setMyOtpDetail={setMyOtpDetail}
                        />


                    </div>
                    <Divider type={'horizontal'}/>
                    <AuthFooterLinkNewMobileSection
                        myMobile={myOtpDetail?.login_by_national_code ? myOtpDetail?.mobile : myMobile}
                        changeMyState={changeMyState}/>
                </div>
            </Card>
        </>);
};


const AuthOTPTimer = ({mobile, otpToken, setOtpToken, setMyOtpDetail}) => {

    const [myTime, setMyTime] = useState(300);

    const [isComplete, setIsComplete] = useState(false);
    const {mutate: sendOtp, isLoading} = useApiSendOtp()

    const {mutate: getOtp, isSuccess: isSuccessGet, isPending} = useApiGetOtp()


    const handleRetry = () => {
        if (!isComplete) return;
        sendOtp({mobile: formatMobileNumber(mobile)}, {
            onSuccess: (res) => {
                setOtpToken(res?.data?.data?.otp_token)
                setIsComplete(false)
            },
            onError: (error) => {
                ApiHandleErrorMessage(error);
            },
        });
    };


    useEffect(() => {
        getOtp({mobile: formatMobileNumber(mobile), otp_token: otpToken}, {
            onSuccess: (data) => {
                setMyOtpDetail(data?.data?.data)
                if (data?.data?.data?.time_left) {
                    setMyTime(data?.data?.data?.time_left);
                    if (parseInt(data?.data?.data?.time_left) > 0) {
                        setIsComplete(false);
                    }
                }
            },
        })
    }, [mobile, otpToken]);

    useEffect(() => {
        if (!isSuccessGet) {
            setMyTime(1)
        }
    }, [isSuccessGet]);

    const timerRenderFN = ({seconds, minutes}) => {
        return (
            <div className="flex">
                <span>{seconds.toString().padStart(2, "0")}</span>
                <span>:</span>
                <span>{minutes.toString().padStart(2, "0")}</span>
            </div>
        );
    };

    return (
        <>

            <div className="flex w-full items-center justify-between gap-2">
                <div className={'mb-2'}>
                    {isPending ? <Spin/> : <RenderIf condition={!isLoading}>

                        {!isComplete ?
                            <p>
                                تا ارسال مجدد کد
                            </p>
                            :
                            <Button className={'font-bold'} loading={isLoading || isPending} onClick={handleRetry}>
                                ارسال مجدد کد فعال‌سازی
                            </Button>}

                    </RenderIf>}

                </div>

                <RenderIf condition={true}>
                    <Timer second={myTime} renderFN={timerRenderFN}
                           onComplete={() => setIsComplete(true)}/>
                </RenderIf>
            </div>
        </>
    );
};

